/**
 * Determines how many decimals to show, specifically used for chart-axis formatters
 * @param value
 * @returns
 */
export function numberOfDecimalsFromValue(value: number) {
  value = Math.abs(value);
  return value < 1 ? 3 : value >= 100 ? 0 : 2;
}
